/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import Dropdown from "./dropdown";
import Footer from "./footer";
import SoftSelect from "components/SoftSelect";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

import { v4 as uuidV4 } from "uuid";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style, fontSize: "15px" }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style, fontSize: "14px" }}>
      {children}
    </th>
  );
};

const provinceOption = [
  {
    value: "An giang",
    label: "An giang",
  },
  {
    value: "Cần thơ",
    label: "Cần thơ",
  },
  {
    value: "TP Hồ Chí Minh",
    label: "TP Hồ Chí Minh",
  },
];

const districtOption = [
  {
    value: "Châu thành",
    label: "Châu thành",
  },
  {
    value: "Long xuyên",
    label: "Long xuyên",
  },
  {
    value: "Chợ mới",
    label: "Chợ mới",
  },
];

const taxAuthoritiesOption = [
  {
    value: "Cục thuế TP.HCM",
    label: "Cục thuế TP.HCM",
  },
  {
    value: "Cục thuế An giang",
    label: "Cục thuế An giang",
  },
];
const DVTOption = [
  {
    value: "kg",
    label: "Kg",
  },
  {
    value: "tấn",
    label: "Tấn",
  },
  {
    value: "lít",
    label: "Lít",
  },
  {
    value: "chai",
    label: "Chai",
  },
  {
    value: "bao",
    label: "Bao",
  },
  {
    value: "cái",
    label: "Cái",
  },
  {
    value: "chiếc",
    label: "Chiếc",
  },
  {
    value: "hộp",
    label: "Hộp",
  },
];

const dataTable = [
  {
    onlyTitle: true,
    bold: true,
    id: {
      value: uuidV4(),
      bg: true,
    },
    symbol: {
      type: "input",
      value: null,
      bg: false,
    },
    number: {
      type: "input",
      value: null,
      bg: false,
    },
    date: {
      type: "input",
      value: null,
      bg: false,
    },
    goodsName: {
      type: "input",
      value: null,
      bg: false,
    },
    DVT: {
      type: "select",
      value: null,
      bg: false,
      option: DVTOption,
    },
    quantityPurchased: {
      type: "input",
      value: 0,
      bg: false,
    },
    taxPaid: {
      type: "input",
      value: 0,
      bg: false,
    },
    amountOfConsumption: {
      type: "input",
      value: 0,
      bg: false,
    },
    amountOfMaterialsPerProduct: {
      type: "input",
      value: 0,
      bg: false,
    },
    TTDBTaxPerProduct: {
      type: "input",
      value: 0,
      bg: false,
    },
    TTDBTaxNotDeducted: {
      type: "input",
      value: 0,
      bg: false,
    },
    TTDBTaxDeducted: {
      type: "input",
      value: 0,
      bg: false,
    },
    TTDBTaxNotAfter: {
      type: "input",
      value: 0,
      bg: false,
    },
  },
];
const dataTable2 = [
  {
    onlyTitle: true,
    bold: true,
    id: {
      value: uuidV4(),
      bg: true,
    },
    symbol: {
      type: "input",
      value: null,
      bg: false,
    },
    number: {
      type: "input",
      value: null,
      bg: false,
    },
    date: {
      type: "input",
      value: null,
      bg: false,
    },
    goodsName: {
      type: "input",
      value: null,
      bg: false,
    },
    DVT: {
      type: "select",
      value: null,
      bg: false,
      option: DVTOption,
    },
    quantityPurchased: {
      type: "input",
      value: 0,
      bg: false,
    },
    taxPaid: {
      type: "input",
      value: 0,
      bg: false,
    },
    amountOfConsumption: {
      type: "input",
      value: 0,
      bg: false,
    },
    TTDBTaxPerProduct: {
      type: "input",
      value: 0,
      bg: false,
    },
    TTDBTaxNotDeducted: {
      type: "input",
      value: 0,
      bg: false,
    },
    TTDBTaxDeducted: {
      type: "input",
      value: 0,
      bg: false,
    },
    TTDBTaxNotAfter: {
      type: "input",
      value: 0,
      bg: false,
    },
  },
];

export default function AppendixTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);
  const [data2, setData2] = useState(dataTable2);

  useEffect(() => {
    setFieldValue("valuesTable", data);
    setFieldValue("valuesTable2", data2);
  }, [data, data2]);

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id.value === id) {
          return { ...item, [name]: { ...item[name], value } };
        }
        return item;
      })
    );
  };

  const addNewRow = (tableName) => {
    if (tableName === "table") {
      const newRow = {
        onlyTitle: true,
        bold: true,
        id: {
          value: uuidV4(),
          bg: true,
        },
        symbol: {
          type: "input",
          value: null,
          bg: false,
        },
        number: {
          type: "input",
          value: null,
          bg: false,
        },
        date: {
          type: "input",
          value: null,
          bg: false,
        },
        goodsName: {
          type: "input",
          value: null,
          bg: false,
        },
        DVT: {
          type: "select",
          value: null,
          bg: false,
          option: DVTOption,
        },
        quantityPurchased: {
          type: "input",
          value: 0,
          bg: false,
        },
        taxPaid: {
          type: "input",
          value: 0,
          bg: false,
        },
        amountOfConsumption: {
          type: "input",
          value: 0,
          bg: false,
        },
        amountOfMaterialsPerProduct: {
          type: "input",
          value: 0,
          bg: false,
        },
        TTDBTaxPerProduct: {
          type: "input",
          value: 0,
          bg: false,
        },
        TTDBTaxNotDeducted: {
          type: "input",
          value: 0,
          bg: false,
        },
        TTDBTaxDeducted: {
          type: "input",
          value: 0,
          bg: false,
        },
        TTDBTaxNotAfter: {
          type: "input",
          value: 0,
          bg: false,
        },
      };
      setData((prev) => [...prev, newRow]);
    } else {
      const newRow = {
        onlyTitle: true,
        bold: true,
        id: {
          value: uuidV4(),
          bg: true,
        },
        symbol: {
          type: "input",
          value: null,
          bg: false,
        },
        number: {
          type: "input",
          value: null,
          bg: false,
        },
        date: {
          type: "input",
          value: null,
          bg: false,
        },
        goodsName: {
          type: "input",
          value: null,
          bg: false,
        },
        DVT: {
          type: "select",
          value: null,
          bg: false,
          option: DVTOption,
        },
        quantityPurchased: {
          type: "input",
          value: 0,
          bg: false,
        },
        taxPaid: {
          type: "input",
          value: 0,
          bg: false,
        },
        amountOfConsumption: {
          type: "input",
          value: 0,
          bg: false,
        },
        TTDBTaxPerProduct: {
          type: "input",
          value: 0,
          bg: false,
        },
        TTDBTaxNotDeducted: {
          type: "input",
          value: 0,
          bg: false,
        },
        TTDBTaxDeducted: {
          type: "input",
          value: 0,
          bg: false,
        },
        TTDBTaxNotAfter: {
          type: "input",
          value: 0,
          bg: false,
        },
      };
      setData2((prev) => [...prev, newRow]);
    }
  };

  const removeRow = (tableName) => {
    if (tableName === "table") {
      if (data.length !== 1) {
        data.pop();
        const newRow = data;
        setData([...newRow]);
      }
    } else {
      if (data.length !== 1) {
        data.pop();
        const newRow = data;
        setData2([...newRow]);
      }
    }
  };

  return (
    <>
      <Box display="flex" flexDirection="column" mt={5}>
        <Box display="flex" justifyContent="space-between">
          <SoftTypography component="label" variant="caption" fontWeight="bold" mb={0.5}>
            I.Bảng tính thuế tiêu thụ đặt biệt (TTĐB) được khấu trừ của nguyên liệu mua vào, nhập
            khẩu sản xuất hàng chịu thuế TTĐB
          </SoftTypography>
        </Box>
        <Box>
          <table style={tableStyle}>
            <thead>
              <tr>
                <Th style={{ textAlign: "center" }} rowSpan="2">
                  STT
                </Th>
                <Th style={{ textAlign: "center" }} colSpan="3">
                  Chứng từ hoặc biên lai nộp thuế TTĐB
                </Th>
                <Th style={{ textAlign: "center" }} rowSpan="2">
                  Tên hàng hóa
                </Th>
                <Th style={{ textAlign: "center" }} rowSpan="2">
                  Đơn vị tính
                </Th>
                <Th style={{ textAlign: "center" }} rowSpan="2">
                  Số lượng nguyên vật liệu mua vào, nhập khẩu
                </Th>
                <Th style={{ textAlign: "center" }} rowSpan="2">
                  Số thuế TTĐB đã nộp
                </Th>
                <Th style={{ textAlign: "center" }} rowSpan="2">
                  Số lượng tiêu thụ trong kỳ
                </Th>
                <Th style={{ textAlign: "center" }} rowSpan="2">
                  Lượng nguyên liệu trên 1 đơn vị sản phẩm tiêu thụ
                </Th>
                <Th style={{ textAlign: "center" }} rowSpan="2">
                  Thuế TTĐB trên 1 đơn vị nguyên liệu đầu vào
                </Th>
                <Th style={{ textAlign: "center" }} rowSpan="2">
                  Số thuế TTĐB đầu vào chưa được khấu trừ kỳ trước chuyển sang
                </Th>
                <Th style={{ textAlign: "center" }} rowSpan="2">
                  Số thuế TTĐB đầu vào được khấu trừ trong kỳ tương ứng hàng hóa bán ra trong kỳ
                </Th>
                <Th style={{ textAlign: "center" }} rowSpan="2">
                  Thuế TTĐB chưa được khấu trừ chuyển kỳ sau
                </Th>
              </tr>
              <tr>
                <Th style={{ textAlign: "center" }}>Ký hiệu</Th>
                <Th style={{ textAlign: "center" }}>Số</Th>
                <Th style={{ textAlign: "center" }}>Ngày tháng,năm phát hành</Th>
              </tr>
              <tr>
                <Th style={{ textAlign: "center" }}>(01)</Th>
                <Th style={{ textAlign: "center" }}>(02)</Th>
                <Th style={{ textAlign: "center" }}>(03)</Th>
                <Th style={{ textAlign: "center" }}>(04)</Th>
                <Th style={{ textAlign: "center" }}>(05)</Th>
                <Th style={{ textAlign: "center" }}>(06)</Th>
                <Th style={{ textAlign: "center" }}>(07)</Th>
                <Th style={{ textAlign: "center" }}>(08)</Th>
                <Th style={{ textAlign: "center" }}>(09)</Th>
                <Th style={{ textAlign: "center" }}>(10)</Th>
                <Th style={{ textAlign: "center" }}>(11)</Th>
                <Th style={{ textAlign: "center" }}>(12)</Th>
                <Th style={{ textAlign: "center" }}>{`(13)=(9)x(10)x(11) và (13)<=(8)+(12)`}</Th>
                <Th style={{ textAlign: "center" }}>{`(14)=(8)+(12)-(13)>0`}</Th>
              </tr>
            </thead>
            <tbody>
              {data &&
                data.length > 0 &&
                data.map((row, index) => (
                  <tr key={row.id.value + index}>
                    <Td
                      row={""}
                      style={{
                        textAlign: "center",
                        background: "transparent",
                      }}
                    >
                      {index + 1}
                    </Td>

                    <Td
                      row={row}
                      style={{
                        textAlign: "right",
                        background: !row.symbol.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.symbol?.type !== "input" ? (
                        row.symbol.value
                      ) : (
                        <InputTable
                          type={"text"}
                          id={row.id.value}
                          name="symbol"
                          value={row.symbol.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>

                    <Td
                      row={row}
                      style={{
                        textAlign: "right",
                        background: !row.number.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.number?.type !== "input" ? (
                        row.number.value
                      ) : (
                        <InputTable
                          type={"text"}
                          id={row.id.value}
                          name="number"
                          value={row.number.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>

                    <Td
                      row={row}
                      style={{
                        textAlign: "right",
                        background: !row.date.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.date?.type !== "input" ? (
                        row.date.value
                      ) : (
                        <InputTable
                          fields={"date"}
                          type={"text"}
                          id={row.id.value}
                          name="date"
                          value={row.date.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>

                    <Td
                      row={row}
                      style={{
                        textAlign: "right",
                        background: !row.goodsName.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.goodsName?.type !== "input" ? (
                        row.goodsName.value
                      ) : (
                        <InputTable
                          type={"text"}
                          id={row.id.value}
                          name="goodsName"
                          value={row.goodsName.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>

                    <Td
                      row={row}
                      style={{
                        textAlign: "left",
                        background: !row.DVT.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.DVT.bg ? (
                        row.DVT.value
                      ) : row.DVT?.type === "select" ? (
                        <SelectTable
                          name="DVT"
                          id={row.id.value}
                          option={row.DVT.option ? row.DVT.option : defaultOption}
                          onSelect={handleChange}
                        />
                      ) : (
                        <InputTable
                          id={row.id.value}
                          name="DVT"
                          value={row.DVT.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>

                    <Td
                      row={row}
                      style={{
                        textAlign: "right",
                        background: !row.quantityPurchased.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.quantityPurchased?.type !== "input" ? (
                        row.quantityPurchased.value
                      ) : (
                        <InputTable
                          type={"number"}
                          id={row.id.value}
                          name="quantityPurchased"
                          value={row.quantityPurchased.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>

                    <Td
                      row={row}
                      style={{
                        textAlign: "left",
                        background: !row.taxPaid.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.taxPaid?.type !== "input" ? (
                        row.taxPaid.value
                      ) : (
                        <InputTable
                          type={"number"}
                          id={row.id.value}
                          name="taxPaid"
                          value={row.taxPaid.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>

                    <Td
                      row={row}
                      style={{
                        textAlign: "left",
                        background: !row.amountOfConsumption.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.amountOfConsumption?.type !== "input" ? (
                        row.amountOfConsumption.value
                      ) : (
                        <InputTable
                          type={"number"}
                          id={row.id.value}
                          name="amountOfConsumption"
                          value={row.amountOfConsumption.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>

                    <Td
                      row={row}
                      style={{
                        textAlign: "left",
                        background: !row.amountOfMaterialsPerProduct.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.amountOfMaterialsPerProduct?.type !== "input" ? (
                        row.amountOfMaterialsPerProduct.value
                      ) : (
                        <InputTable
                          type={"number"}
                          id={row.id.value}
                          name="amountOfMaterialsPerProduct"
                          value={row.amountOfMaterialsPerProduct.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>

                    <Td
                      row={row}
                      style={{
                        textAlign: "left",
                        background: !row.TTDBTaxPerProduct.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.TTDBTaxPerProduct?.type !== "input" ? (
                        row.TTDBTaxPerProduct.value
                      ) : (
                        <InputTable
                          type={"number"}
                          id={row.id.value}
                          name="TTDBTaxPerProduct"
                          value={row.TTDBTaxPerProduct.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>

                    <Td
                      row={row}
                      style={{
                        textAlign: "left",
                        background: !row.TTDBTaxNotDeducted.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.TTDBTaxNotDeducted?.type !== "input" ? (
                        row.TTDBTaxNotDeducted.value
                      ) : (
                        <InputTable
                          type={"number"}
                          id={row.id.value}
                          name="TTDBTaxNotDeducted"
                          value={row.TTDBTaxNotDeducted.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>

                    <Td
                      row={row}
                      style={{
                        textAlign: "left",
                        background: !row.TTDBTaxDeducted.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.TTDBTaxDeducted?.type !== "input" ? (
                        row.TTDBTaxDeducted.value
                      ) : (
                        <InputTable
                          type={"number"}
                          id={row.id.value}
                          name="TTDBTaxDeducted"
                          value={row.TTDBTaxDeducted.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>

                    <Td
                      row={row}
                      style={{
                        textAlign: "left",
                        background: !row.TTDBTaxNotAfter.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.TTDBTaxNotAfter?.type !== "input" ? (
                        row.TTDBTaxNotAfter.value
                      ) : (
                        <InputTable
                          type={"number"}
                          id={row.id.value}
                          name="TTDBTaxNotAfter"
                          value={row.TTDBTaxNotAfter.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>
                  </tr>
                ))}

              <tr>
                <Td
                  colSpan="1"
                  row={{ bold: true }}
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                  }}
                ></Td>
                <Td
                  colSpan="3"
                  row={{ bold: true }}
                  style={{
                    textAlign: "center",
                    // paddingRight: "78px",
                    background: "#ddeff3",
                  }}
                >
                  Tổng cộng
                </Td>
                <Td
                  colSpan="1"
                  row={{ bold: true }}
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                  }}
                ></Td>
                <Td
                  colSpan="1"
                  row={{ bold: true }}
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                  }}
                ></Td>
                <Td
                  colSpan="1"
                  row={{ bold: true }}
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                  }}
                >
                  <InputTable id={"total"} type={"number"} name="total" value={0} disable={true} />
                </Td>
                <Td
                  style={{
                    textAlign: "left",
                    // paddingRight: "78px",
                    background: "#ddeff3",
                  }}
                >
                  <InputTable id={"total"} type={"number"} name="total" value={0} disable={true} />
                </Td>
                <Td
                  style={{
                    textAlign: "left",
                    // paddingRight: "78px",
                    background: "#ddeff3",
                  }}
                >
                  <InputTable id={"total"} type={"number"} name="total" value={0} disable={true} />
                </Td>
                <Td
                  style={{
                    textAlign: "left",
                    // paddingRight: "78px",
                    background: "#ddeff3",
                  }}
                >
                  <InputTable id={"total"} type={"number"} name="total" value={0} disable={true} />
                </Td>
                <Td
                  style={{
                    textAlign: "left",
                    // paddingRight: "78px",
                    background: "#ddeff3",
                  }}
                >
                  <InputTable id={"total"} type={"number"} name="total" value={0} disable={true} />
                </Td>{" "}
                <Td
                  style={{
                    textAlign: "left",
                    // paddingRight: "78px",
                    background: "#ddeff3",
                  }}
                >
                  <InputTable id={"total"} type={"number"} name="total" value={0} disable={true} />
                </Td>
                <Td
                  style={{
                    textAlign: "left",
                    // paddingRight: "78px",
                    background: "#ddeff3",
                  }}
                >
                  <InputTable id={"total"} type={"number"} name="total" value={0} disable={true} />
                </Td>
                <Td
                  style={{
                    textAlign: "left",
                    // paddingRight: "78px",
                    background: "#ddeff3",
                  }}
                >
                  <InputTable id={"total"} type={"number"} name="total" value={0} disable={true} />
                </Td>
              </tr>
            </tbody>
          </table>
          <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
            <SoftButton variant="gradient" color="dark" onClick={() => addNewRow("table")}>
              Thêm dòng
            </SoftButton>
            <SoftButton variant="gradient" color="light" onClick={() => removeRow("table")}>
              Xóa dòng
            </SoftButton>
          </SoftBox>
        </Box>
      </Box>

      <Box display="flex" flexDirection="column" mt={5}>
        <Box display="flex" justifyContent="space-between">
          <SoftTypography component="label" variant="caption" fontWeight="bold" mb={0.5}>
            II.Bảng tính thuế TTĐB được khấu trừ của hàng hóa nhập khẩu
          </SoftTypography>
        </Box>
        <Box>
          <table style={tableStyle}>
            <thead>
              <tr>
                <Th style={{ textAlign: "center" }} rowSpan="2">
                  STT
                </Th>
                <Th style={{ textAlign: "center" }} colSpan="3">
                  Chứng từ hoặc biên lai nộp thuế TTĐB
                </Th>
                <Th style={{ textAlign: "center" }} rowSpan="2">
                  Tên hàng hóa nhập khẩu đã nộp thuế TTĐB
                </Th>
                <Th style={{ textAlign: "center" }} rowSpan="2">
                  Đơn vị tính
                </Th>
                <Th style={{ textAlign: "center" }} rowSpan="2">
                  Số lượng đơn vị hàng hóa nhập khẩu
                </Th>
                <Th style={{ textAlign: "center" }} rowSpan="2">
                  Số thuế TTĐB ở khâu nhập khẩu đã nộp
                </Th>
                <Th style={{ textAlign: "center" }} rowSpan="2">
                  Số lượng tiêu thụ đã nộp trong kỳ
                </Th>
                <Th style={{ textAlign: "center" }} rowSpan="2">
                  Số thuế TTĐB trên 1 đơn vị hàng hóa nhập khẩu
                </Th>
                <Th style={{ textAlign: "center" }} rowSpan="2">
                  Số thuế TTĐB đầu vào chưa được khấu trừ kỳ trước chuyển sang
                </Th>
                <Th style={{ textAlign: "center" }} rowSpan="2">
                  Số thuế TTĐB đầu vào được khấu trừ trong kỳ tương ứng hàng hóa bán ra trong kỳ
                </Th>
                <Th style={{ textAlign: "center" }} rowSpan="2">
                  Thuế TTĐB chưa được khấu trừ chuyển kỳ sau
                </Th>
              </tr>
              <tr>
                <Th style={{ textAlign: "center" }}>Ký hiệu</Th>
                <Th style={{ textAlign: "center" }}>Số</Th>
                <Th style={{ textAlign: "center" }}>Ngày tháng,năm phát hành</Th>
              </tr>
              <tr>
                <Th style={{ textAlign: "center" }}>(01)</Th>
                <Th style={{ textAlign: "center" }}>(02)</Th>
                <Th style={{ textAlign: "center" }}>(03)</Th>
                <Th style={{ textAlign: "center" }}>(04)</Th>
                <Th style={{ textAlign: "center" }}>(05)</Th>
                <Th style={{ textAlign: "center" }}>(06)</Th>
                <Th style={{ textAlign: "center" }}>(07)</Th>
                <Th style={{ textAlign: "center" }}>(08)</Th>
                <Th style={{ textAlign: "center" }}>(09)</Th>
                <Th style={{ textAlign: "center" }}>(10)=(8)/(7)</Th>
                <Th style={{ textAlign: "center" }}>(11)</Th>
                <Th style={{ textAlign: "center" }}>{`(12)=(9)x(10) và (12)<=(8)+(11)`}</Th>
                <Th style={{ textAlign: "center" }}>{`(13)=(8)+(11)-(12)>0`}</Th>
                {/* <Th style={{ textAlign: "center" }}>(12)</Th> */}
              </tr>
            </thead>
            <tbody>
              {data2 &&
                data2.length > 0 &&
                data2.map((row, index) => (
                  <tr key={row.id.value + index}>
                    <Td
                      row={""}
                      style={{
                        textAlign: "center",
                        background: "transparent",
                      }}
                    >
                      {index + 1}
                    </Td>

                    <Td
                      row={row}
                      style={{
                        textAlign: "right",
                        background: !row.symbol.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.symbol?.type !== "input" ? (
                        row.symbol.value
                      ) : (
                        <InputTable
                          type={"text"}
                          id={row.id.value}
                          name="symbol"
                          value={row.symbol.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>

                    <Td
                      row={row}
                      style={{
                        textAlign: "right",
                        background: !row.number.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.number?.type !== "input" ? (
                        row.number.value
                      ) : (
                        <InputTable
                          type={"text"}
                          id={row.id.value}
                          name="number"
                          value={row.number.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>

                    <Td
                      row={row}
                      style={{
                        textAlign: "right",
                        background: !row.date.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.date?.type !== "input" ? (
                        row.date.value
                      ) : (
                        <InputTable
                          fields={"date"}
                          type={"text"}
                          id={row.id.value}
                          name="date"
                          value={row.date.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>

                    <Td
                      row={row}
                      style={{
                        textAlign: "right",
                        background: !row.goodsName.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.goodsName?.type !== "input" ? (
                        row.goodsName.value
                      ) : (
                        <InputTable
                          type={"text"}
                          id={row.id.value}
                          name="goodsName"
                          value={row.goodsName.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>

                    <Td
                      row={row}
                      style={{
                        textAlign: "left",
                        background: !row.DVT.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.DVT.bg ? (
                        row.DVT.value
                      ) : row.DVT?.type === "select" ? (
                        <SelectTable
                          name="DVT"
                          id={row.id.value}
                          option={row.DVT.option ? row.DVT.option : defaultOption}
                          onSelect={handleChange}
                        />
                      ) : (
                        <InputTable
                          id={row.id.value}
                          name="DVT"
                          value={row.DVT.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>

                    <Td
                      row={row}
                      style={{
                        textAlign: "right",
                        background: !row.quantityPurchased.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.quantityPurchased?.type !== "input" ? (
                        row.quantityPurchased.value
                      ) : (
                        <InputTable
                          type={"number"}
                          id={row.id.value}
                          name="quantityPurchased"
                          value={row.quantityPurchased.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>

                    <Td
                      row={row}
                      style={{
                        textAlign: "left",
                        background: !row.taxPaid.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.taxPaid?.type !== "input" ? (
                        row.taxPaid.value
                      ) : (
                        <InputTable
                          type={"number"}
                          id={row.id.value}
                          name="taxPaid"
                          value={row.taxPaid.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>

                    <Td
                      row={row}
                      style={{
                        textAlign: "left",
                        background: !row.amountOfConsumption.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.amountOfConsumption?.type !== "input" ? (
                        row.amountOfConsumption.value
                      ) : (
                        <InputTable
                          type={"number"}
                          id={row.id.value}
                          name="amountOfConsumption"
                          value={row.amountOfConsumption.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>

                    <Td
                      row={row}
                      style={{
                        textAlign: "left",
                        background: !row.TTDBTaxPerProduct.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.TTDBTaxPerProduct?.type !== "input" ? (
                        row.TTDBTaxPerProduct.value
                      ) : (
                        <InputTable
                          type={"number"}
                          id={row.id.value}
                          name="TTDBTaxPerProduct"
                          value={row.TTDBTaxPerProduct.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>

                    <Td
                      row={row}
                      style={{
                        textAlign: "left",
                        background: !row.TTDBTaxNotDeducted.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.TTDBTaxNotDeducted?.type !== "input" ? (
                        row.TTDBTaxNotDeducted.value
                      ) : (
                        <InputTable
                          type={"number"}
                          id={row.id.value}
                          name="TTDBTaxNotDeducted"
                          value={row.TTDBTaxNotDeducted.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>

                    <Td
                      row={row}
                      style={{
                        textAlign: "left",
                        background: !row.TTDBTaxDeducted.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.TTDBTaxDeducted?.type !== "input" ? (
                        row.TTDBTaxDeducted.value
                      ) : (
                        <InputTable
                          type={"number"}
                          id={row.id.value}
                          name="TTDBTaxDeducted"
                          value={row.TTDBTaxDeducted.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>

                    <Td
                      row={row}
                      style={{
                        textAlign: "left",
                        background: !row.TTDBTaxNotAfter.bg ? "transparent" : "#ddeff3",
                      }}
                    >
                      {row.TTDBTaxNotAfter?.type !== "input" ? (
                        row.TTDBTaxNotAfter.value
                      ) : (
                        <InputTable
                          type={"number"}
                          id={row.id.value}
                          name="TTDBTaxNotAfter"
                          value={row.TTDBTaxNotAfter.value}
                          onChange={handleChange}
                        />
                      )}
                    </Td>
                  </tr>
                ))}

              <tr>
                <Td
                  colSpan="1"
                  row={{ bold: true }}
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                  }}
                ></Td>
                <Td
                  colSpan="3"
                  row={{ bold: true }}
                  style={{
                    textAlign: "center",
                    // paddingRight: "78px",
                    background: "#ddeff3",
                  }}
                >
                  Tổng cộng
                </Td>
                <Td
                  colSpan="1"
                  row={{ bold: true }}
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                  }}
                ></Td>
                <Td
                  colSpan="1"
                  row={{ bold: true }}
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                  }}
                ></Td>
                <Td
                  colSpan="1"
                  row={{ bold: true }}
                  style={{
                    textAlign: "right",
                    background: "#ddeff3",
                  }}
                >
                  <InputTable id={"total"} type={"number"} name="total" value={0} disable={true} />
                </Td>
                <Td
                  style={{
                    textAlign: "left",
                    // paddingRight: "78px",
                    background: "#ddeff3",
                  }}
                >
                  <InputTable id={"total"} type={"number"} name="total" value={0} disable={true} />
                </Td>
                <Td
                  style={{
                    textAlign: "left",
                    // paddingRight: "78px",
                    background: "#ddeff3",
                  }}
                >
                  <InputTable id={"total"} type={"number"} name="total" value={0} disable={true} />
                </Td>
                <Td
                  style={{
                    textAlign: "left",
                    // paddingRight: "78px",
                    background: "#ddeff3",
                  }}
                >
                  <InputTable id={"total"} type={"number"} name="total" value={0} disable={true} />
                </Td>
                <Td
                  style={{
                    textAlign: "left",
                    // paddingRight: "78px",
                    background: "#ddeff3",
                  }}
                >
                  <InputTable id={"total"} type={"number"} name="total" value={0} disable={true} />
                </Td>{" "}
                <Td
                  style={{
                    textAlign: "left",
                    // paddingRight: "78px",
                    background: "#ddeff3",
                  }}
                >
                  <InputTable id={"total"} type={"number"} name="total" value={0} disable={true} />
                </Td>
                <Td
                  style={{
                    textAlign: "left",
                    // paddingRight: "78px",
                    background: "#ddeff3",
                  }}
                >
                  <InputTable id={"total"} type={"number"} name="total" value={0} disable={true} />
                </Td>
              </tr>
            </tbody>
          </table>
          <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
            <SoftButton variant="gradient" color="dark" onClick={addNewRow}>
              Thêm dòng
            </SoftButton>
            <SoftButton variant="gradient" color="light" onClick={removeRow}>
              Xóa dòng
            </SoftButton>
          </SoftBox>
          <Footer formData={formData} />
        </Box>
      </Box>
    </>
  );
}

function InputTable(props) {
  const { id, onChange, type, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name, type });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name, type });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name, type });
    }
  }
  return (
    <input
      type="text"
      style={{
        textAlign: type === "number" ? "right" : "left",
        fontSize: 16,
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}

function SelectTable(props) {
  const { id, onSelect, type, option, name, style, ...rest } = props;
  const [newValue, setNewValue] = useState();
  useEffect(() => {
    if (typeof onSelect === "function") {
      onSelect({ id, value: newValue !== "" ? newValue : "", name, type });
    }
  }, [newValue]);
  return (
    <div style={style}>
      <Dropdown option={option} id={id} newValue={newValue} setNewValue={setNewValue} />
    </div>
  );
}
